import { render } from "./icon-reviewed-counter-3.svg?vue&type=template&id=e7264ec1&scoped=true&component"
const script = {  }

import "./icon-reviewed-counter-3.svg?vue&type=style&index=0&id=e7264ec1&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7264ec1"]])

export default __exports__